import _ from "lodash";
import React, { useState, useContext, useMemo } from "react";
import classes from "./CollaboratorV2ListWithModal.scss";
import { useI18n } from "Hooks";
import classNames from "classnames";
import SelectedCollaboratorsList from "AppComponents/CollaboratorV2/components/SelectedCollaboratorsList";
import CollaboratorV2AddEditModal from "AppComponents/CollaboratorV2/components/CollaboratorV2AddEditModal";
import { AddOutlined, WarningTriangleFilled } from "@toddle-edu/ds-icons";
import { Button, useDSContext } from "@toddle-edu/ds-web";
import { CollaboratorV2Context } from "AppComponents/CollaboratorV2/modules/Modules";

const CollaboratorV2ListWithModal = ({ isError, testId }) => {
  const { t } = useI18n(["common", "project"]);

  const { dsVersion } = useDSContext();
  const isDSV2 = dsVersion === "2.0";

  const contextValue = useContext(CollaboratorV2Context);
  const {
    labels,
    disabled: isViewModeEnabled,
    required,
    selectedCollaborators,
    removeCollaborators,
  } = contextValue;

  const [showAddEditModal, setShowAddEditModal] = useState(false);

  const toggleAddModal = () => {
    setShowAddEditModal(prevState => {
      return !prevState;
    });
  };

  const showErrorState = useMemo(() => {
    return !showAddEditModal && isError && _.size(selectedCollaborators) == 0;
  }, [showAddEditModal, isError, selectedCollaborators]);

  const headerTextContainerClass = classNames({
    [classes.headerTextContainer]: true,
    [classes.headerTextContainerV2]: isDSV2,
  });

  const headerTextClass = classNames({
    "text-label-2": !isDSV2,
    "text-label": isDSV2,
  });

  const subtextClass = classNames({
    "text-body-2": !isDSV2,
    [classes.headerSubtext]: !isDSV2,
    "text-body-s": isDSV2,
    [classes.headerSubTextV2]: isDSV2,
  });

  const bodyContainerClasses = classNames({
    [classes.bodyContainer]: true,
    [classes.bodyContainerV2]: isDSV2,
  });

  return (
    <div className={classes.container}>
      <div className={classes.headerContainer}>
        <div className={headerTextContainerClass}>
          <div className={headerTextClass}>
            {required
              ? t("common:mandatory_label", { label: t(labels.headerText) })
              : t(labels.headerText)}
          </div>
          <span className={subtextClass}>{t(labels.headerSubText)}</span>
        </div>
        {!isViewModeEnabled ? (
          <Button
            onClick={toggleAddModal}
            _legacy_variant="outlined"
            type="outlined"
            variant="neutral"
            icon={<AddOutlined />}
            testId={`${testId}-add`}
          >
            {t("common:add")}
          </Button>
        ) : null}
      </div>

      {_.size(selectedCollaborators) != 0 ? (
        <div className={bodyContainerClasses}>
          <SelectedCollaboratorsList
            clickToExpand={true}
            selectedCollaborators={_.filter(
              selectedCollaborators,
              item => item
            )}
            onRemoveCollaborator={removeCollaborators}
            showWarningModalOnRemoval={true}
            showExternalCollaboratorOptions={true}
            avatarSize={isDSV2 ? "medium" : undefined}
            testId={testId}
          />
        </div>
      ) : null}

      {showAddEditModal ? (
        <CollaboratorV2AddEditModal
          onCloseModal={toggleAddModal}
          closeModalOnDone={true}
        />
      ) : null}
      {showErrorState ? (
        <div className={classes.errorTextContainer}>
          <WarningTriangleFilled size="xxx-small" variant="critical" />
          <span className={classNames("text-body-3", classes.criticalText)}>
            {t("common:required")}
          </span>
        </div>
      ) : null}
    </div>
  );
};

export default CollaboratorV2ListWithModal;
